import {RequestStatus, RequestMilestone} from '.'

export const REQUEST_STATUS_NAME: Record<RequestStatus, string> = {
  created: 'Loan request created',
  'loans-coordinator-check': 'Loans coordinator check',
  'lending-manager-check': 'Lending manager check',
  'financial-controller-check': 'Financial controller check',
  'director-check': 'Director approval',
  approved: 'Signing the contract',
  'aml-check': 'AML check',
  'ready-to-open': 'Ready to open',
  opened: 'Opened request',
  declined: 'Request cancelled',

  'final-approval': 'Final Approval',
}

export const REQUEST_MILESTONE_NAME: Record<RequestMilestone, string> = {
  'manager-assigned': 'Assign manager',
  'borrower-assigned': 'Assign borrower',
  'broker-assigned': 'Assign broker',
  'properties-set': 'Offer amount, dates, interest',
  'security-items-added': 'Add security items',
  'forecast-created': 'Create forecast',
  'forecast-updated': 'Check forecast',
  'documents-checked': 'Document check',
  'loan-summary-added': 'Loan summary & feasibility file',
  'financial-checked': 'Financial check',
  'bonus-granted': 'Offer bonus percent',
  'financial-reviewed': 'Write a review',
  'aml-check-initiated': 'Initiate AML process',
  'offer-signed': 'Sign the offer with borrower and set the fees',

  'fees-checked': 'Fees check',
}

export const REQUEST_APPROVED_STATUSES = [
  'approved',
  'aml-check',
  'ready-to-open',
]
export const REQUEST_DECLINED_STATUSES = [
  'declined',
]
export const REQUEST_CURRENT_STATUSES = [
  'created',
  'loans-coordinator-check',
  'lending-manager-check',
  'financial-controller-check',
  'director-check',
  // 'opened'
]
